import './AcademicDetailsComponent.css';
let AcademicDetailsComponent = (props) =>{
    return(     
        <tr>
            <td className='samestyling_td'>{props.Stream}</td>
            <td className='samestyling_td'>{props.BoardUnivercity}</td>
            <td className='samestyling_td'>{props.PassingYearA}</td>
            <td className='samestyling_td'>{props.PercentageA}</td>
        </tr>
    );
}

export default AcademicDetailsComponent;